<template>
  <div style="position: relative;">
    <preload-btn v-if="!car_id"
                 @click.native.prevent="resultsNotificationBtn"
                 :load="load"
                 :class="[{ active: sub }]"
                 class="results-notification-btn">
      <save-search-active-icon v-if="sub"/>
      <save-search-icon v-else/>

      <span>{{ sub ? "Leitin vistuð" : "Vista leit" }}</span>
    </preload-btn>

    <button v-if="car_id" @click.prevent="resultsNotificationBtn()"
            :class="['main-header-right-fav-btn', { active: activeBtn }]">
      <save-search-star :active="activeBtn"/>
      <span>{{ saveCarTitle }}</span>
    </button>

    <!-- Popup -->
    <div v-if="showMain" class="results-notification-btn-content"
         v-click-outside="closeEvent"
         style="display: block !important;"
    >

      <div v-if="!car_id" class="results-notification-btn-content-title">
        {{ getTitle }}
      </div>
      <div v-show="!car_id && index != 'brands'" v-for="(data, index) in filterName()" :key="index"
           class="results-notification-btn-content-data">
        {{ data }}
      </div>
      <!--                    <span class="results-notification-btn-content-tag">Panorama topplúga</span>-->
      <div class="results-notification-btn-content-email">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" width="29px" height="29px">
          <g fill="none" fill-rule="evenodd">
            <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
            <path fill="#FFF" d="M5 8h18v13H5z"/>
            <path fill="#6F9F13"
                  d="M5 21.0909091h18V8H5v13.0909091zm.81818182-11.43736365v-.83536363H22.1818182v.83536363L14 15.9257273 5.81818182 9.65354545zM17.078 14.5871818L22.1818182 10.682v9.0122727L17.078 14.5871818zM5.81818182 10.682l5.10545458 3.906-5.10545458 5.1087273V10.682zm10.60445458 4.4067273l5.1807272 5.184H6.39909091l5.18072729-5.1823637L14 16.9419091l2.4226364-1.8531818z"/>
          </g>
        </svg>
        <!--                <div style="font-size: 14px; color: #0a6aa1;">{{subscriber}}</div>-->
        <div v-if="!car_id">
          Fá senda nýja leitarniðurstöður á netfangið
          <a href="#" class="results-notification-btn-content-email-link">
            {{ user ? user.email : "Einu sinni á dag" }}
          </a>
        </div>
        <div v-if="car_id">
          Verðvakt virkjuð. Þú færð sendan tölvupóst þegar verð breytist.
          <a href="#" class="results-notification-btn-content-email-link">
            {{ user ? user.email : "Einu sinni á dag" }}
          </a>
        </div>
      </div>
      <!--            <div v-if="!subscriber" class="results-notification-btn-content-email-fields">-->
      <!--                <input id="email" @click="resetClassError(this)" v-model="email" type="text" placeholder="Sláðu þitt netfang" class="results-notification-btn-content-email-field" :class="[{'not-valid': !validEmailFlag}]">-->
      <!--                <button @click="saveSearch" class="results-notification-btn-content-email-btn">Skrá mig</button>-->
      <!--            </div>-->
      <hr class="hr"/>

      <!--            <div style="color: red; font-size: 15px;">-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</div>-->
      <div class="results-notification-btn-content-noti">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" width="29px" height="29px">
          <g fill="none" fill-rule="evenodd">
            <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
            <path fill="#FFF" fill-rule="nonzero"
                  d="M20.2375 12.5751328c0-3.96376135-2.1875-5.31209-4.2333333-5.61262108 0-.02030616.0041666-.04061231.0041666-.0649797C16.0083333 6.39800062 15.5541667 6 15 6c-.5541667 0-.9916667.39800062-.9916667.89753202 0 .02436739 0 .04467354.0041667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074348C9.7625 17.204936 8.58333333 17.7004061 7 19h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.4248672zM15 21c2.073501 0 3.7756286-.4627907 4-1h-8c.2166344.5372093 1.926499 1 4 1z"/>
          </g>
        </svg>
        <div>
          Push notifications<br/><a href="#">Fá tilkynningu strax í vafra</a>
        </div>
        <label for="sc1" class="switch-checkbox">
          <input type="checkbox" id="sc1"/>
          <div class="switch-checkbox-mark"></div>
        </label>
      </div>
      <div class="footer">
        <hr class="hr"/>
        <div v-if="sub > 0" class="del-btn" @click="showConfirm = new Date().getTime()">
          <trash-icon/>
          Eyða
        </div>
        <confirm :del="delSearch" :showCo="showConfirm" :cancelConfirm="closeEvent"></confirm>
      </div>
    </div>
  </div>
</template>

<script>
import confirm from "./Confirm.vue";
import preloadBtn from "./PreloadBtn.vue";
import saveSearchActiveIcon from "./svg/saveSearchActiveIcon.vue";
import saveSearchIcon from "./svg/saveSearchIcon.vue";
import trashIcon from "./svg/trashIcon.vue";
import SaveSearchStar from "./svg/SaveSearchStar";
import axios from "../helpers/axios";
import {mapActions} from "vuex";
// import fnc from "@/helpers/func";

export default {
  data: function () {
    return {
      showMain: false,
      showConfirm: false,
      load: false,
      toggleBtnColorFlag: false,
      validEmailFlag: true
    };
  },
  props: [
    "filters",
    "car_id",
    "is_new_car"
  ],
  components: {
    confirm,
    preloadBtn,
    saveSearchActiveIcon,
    saveSearchIcon,
    trashIcon,
    SaveSearchStar
  },
  watch: {
    filters() {
      this.showMain = false;
      this.showConfirm = false;
    },
  },
  methods: {
    ...mapActions('favorites', {
      delFav: 'DEL',
      addFav: 'ADD'
    }),
    delSearch() {
      this.delFav({
        sub: this.sub,
        car_id: this.car_id
      })
          .then(response => {
            if (response.data.status == 1) {
              this.$store.state.sub = 0;
              this.$store.state.dealers.newCar.is_sub = 0;

              this.showConfirm = false;
              this.showMain = false;
            }
          });
    },
    resultsNotificationBtn() {
      if (this.user) {
        this.saveSearch();
        this.filterName();
        this.showMain = !this.showMain;
        if (!this.showMain) {
          this.showConfirm = false;
        }
      } else {
        this.$store.state.popup = "sign-in";
      }
    },
    resetClassError() {
      this.validEmailFlag = true;
    },
    saveSearch() {
      let validationRegExp = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if (!this.email.match(validationRegExp)) {
        this.validEmailFlag = false;
        // return
      }

      if (!this.car_id) {
        this.load = this.sub > 0 ? false : true;
        axios.post(`/new-cars/save-search`,
            {
              filters: this.getFilter,
              type: this.getType//this.$route.name == 'OldCars' ? 1 : 3
            },
            {emulateJSON: false}
        ).then(response => {
          this.load = false;
          if (!!response.data) {
            if (response.data.status > 0) {
              this.$store.state.sub = response.data.status;
              // this.showMain = false;
              this.toggleBtnColorFlag = true;
            }
          }
        }).catch(response => {
          this.error = response;
          this.load = false;
        });
      } else {
        this.addFav({
          car_id: this.car_id,
          email: this.email,
          is_new_car: this.is_new_car
        }).then(
            response => {
              if (!!response.data) {
                if (response.data.status && response.data.status == "OK") {
                  if (this.is_new_car) {
                    this.$store.state.dealers.newCar.is_sub = response.data.favorites_id;
                  } else {
                    this.$store.state.sub = response.data.favorites_id;
                  }
                  // this.$store.state.dealers.newCar.is_sub = response.data.favorites_id;
                }
              }
            },
            response => {
              this.error = response;
            }
        );
      }
    },
    filterName() {
      let f = this.filters;
      let res = {};
      for (let k in f) {
        let item = f[k];
        if (typeof res[item.type] == "undefined") {
          res[item.type] = [];
        }
        res[item.type].push(item.name);
      }

      let res2 = {};
      for (let k in res) {
        let item = res[k];

        res2[k] = item.join(", ");
      }
      return res2;
    },
    closeEvent() {
      this.showMain = false;
      this.showConfirm = false;
    }
  },
  computed: {
    sub() {
      if (this.is_new_car) {
        return this.$store.state.dealers.newCar.is_sub;
      }
      return this.$store.state.sub;
    },
    getType() {
      let name = this.$route.name;
      if (name == 'CarsInStock') {
        return 7;
      }
      if (name == 'k7Cars') {
        return 1;
      }
      return name == 'OldCars' ? 1 : 3;
    },
    email() {
      return this.user.email;
    },
    user() {
      return this.$store.state.profile.user;
    },
    saveCarTitle() {
      return this.activeBtn ? "Vistað í eftirlæti" : "Vista í eftirlæti";
    },
    activeBtn() {
      return this.sub > 0;
    },
    getFilter: function () {
      if (this.$route.name == 'k7Cars') {
        const addToFilter = {k7: true};
        return {...this.$store.state.carFilter, ...addToFilter};
      } else if (this.$route.name == 'OldCars') {
        return this.$store.state.carFilter;
      } else {
        return this.$store.state.dealerFilterData;
      }
    },
    getTitle() {
      const routeName = this.$route.name;
      if (routeName == 'k7Cars') {
        return 'K7 bílasölur' + " " + (this.filterName().brands ? this.filterName().brands : '');
      }
      return this.filterName().brands ? this.filterName().brands : "Allir framleiðendur"
    }
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        setTimeout(function () {
          document.addEventListener("click", handler);
        }, 10);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>
